import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { AuthNGuardService } from '../services/authn-guard.service';

@Injectable()
export class CanActivateChildGuard implements CanActivateChild {

    constructor(private _authService: AuthNGuardService) {}

    async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
        return await this._authService.canActivate(route);
    }
}
